class EditConfirmedEvent extends CustomEvent {
    constructor(confirmedText) {
        super('editConfirmed', {
            detail: confirmedText,
            bubbles: true,
            cancelable: true
        });
        this.confirmedText = confirmedText;
    }
}

class EditTextModal {
    constructor() {
        this._rootElement = null;
        this._textArea = null;
        this._sendBtn = null;
        this._clearBtn = null;
        this._closeBtn = null;
        this._events = new EventTarget();
    }

    get events() {
        return this._events;
    }

    showModal(existingText) {
        if (existingText) {
            existingText = existingText.replace(/\0/g, '');
          //  this.textArea.value = existingText;

            this.textArea.value = "";
        }

        document.body.appendChild(this.rootElement);
        this.textArea.focus();
        this.textArea.selectionStart = this.textArea.value.length;
    }

get rootElement() {
    if (!this._rootElement) {
        this._rootElement = document.createElement('div');
        this._rootElement.classList.add('floatingInputBox');

        this._rootElement.appendChild(this.textArea);

        const inputRow = document.createElement('div');
        inputRow.classList.add('modalKeyboardInputRow');
       // inputRow.appendChild(this.clearBtn);  
        inputRow.appendChild(this.closeBtn);
        inputRow.appendChild(this.sendBtn);

        this._rootElement.appendChild(inputRow);
    }
    return this._rootElement;
}

    get closeBtn() {
        if (!this._closeBtn) {
            this._closeBtn = document.createElement('button');
            this._closeBtn.classList.add('btn-keyboard-flat-cancel');
            this._closeBtn.innerText = 'Cancel'; 
            this._closeBtn.addEventListener('click', (e) => {
                this.rootElement.remove();
                e.stopPropagation();
            });
        }
        return this._closeBtn;
    }

    get textArea() {
        if (!this._textArea) {
            this._textArea = document.createElement('textarea');
            this._textArea.classList.add('modalKeyboardTextArea');
            this._textArea.placeholder = 'Enter text...';

            this._textArea.addEventListener('keydown', (e) => {
                e.stopPropagation();
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    this.sendBtn.click();
                }
            });
        }
        return this._textArea;
    }

    get sendBtn() {
        if (!this._sendBtn) {
            this._sendBtn = document.createElement('button');
            this._sendBtn.classList.add('btn-keyboard-flat');
            this._sendBtn.innerText = 'Submit';

            this._sendBtn.addEventListener('click', (e) => {
                const text = this.textArea.value.trim();
                if (text.length > 0) {
                    this.events.dispatchEvent(new EditConfirmedEvent(text));
                }
                this.textArea.value = '';
                this.rootElement.remove();
                e.stopPropagation();
            });
        }
        return this._sendBtn;
    }

    get clearBtn() {
        if (!this._clearBtn) {
            this._clearBtn = document.createElement('button');
            this._clearBtn.classList.add('btn-keyboard-flat', 'clearBtn');
            this._clearBtn.innerText = 'Clear';

            this._clearBtn.addEventListener('click', (e) => {
                this.textArea.value = '';
                this.textArea.focus();
                e.stopPropagation();
            });
        }
        return this._clearBtn;
    }
}

module.exports = {
    EditTextModal,
    EditConfirmedEvent
};
